module.exports = __webpack_public_path__ + "img/32963-026.b1bd6b55.jpg";